export default __webpack_public_path__ + "static/media/twitter.4f08fcbe.svg";